import { Button, Center } from "@mantine/core";
import { IconSend } from "@tabler/icons-react";
import { useSubmitState } from "hooks/useSubmitState";

export interface BButtonEmailProps {
  f: Function;
  disabled?: boolean;
}

export const BButtonEmail = ({ f, disabled }: BButtonEmailProps) => {
  const [submitState, setSubmitState] = useSubmitState();

  const submit = async () => {
    setSubmitState("pending-response");
    await f();
    setSubmitState("success");
  };

  return (
    <Button
      variant="outline"
      loading={submitState === "pending-response"}
      onClick={submit}
      disabled={disabled}
    >
      <Center>
        <IconSend size={18} />
      </Center>
    </Button>
  );
};
